<template>
    <div @click="$refs.filepicker.click()">
        <slot></slot>
        <input type="file" v-bind:class="classstyle" v-on:change="changeFile($event)" v-bind:accept="accept" ref="filepicker">
    </div>
</template>

<script>
    export default {
        props: {
            accept: { default: function () { return ''; }},
            classstyle: { default: function () { return ''; }},
            maxsize:{ default: function () { return false ;}} /* arriva in kb ma viene convertito in byte */
        },
        data: function() {
            return {
                file: null,
                realMaxSize: false
            }
        },
        computed: {
        },
        watch: { 
           file: function (newVal,oldValue) {
                this.$emit('on-change-src',{
                    file:this.file
                });
            },
            maxsize: function (newVal,oldValue) {
                this.realMaxSize = newVal * 1024; /* mi arriva in kb quindi va convertito in b */
            },
        },
        mounted(){
            if (this.maxsize) this.realMaxSize = this.maxsize * 1024; /* mi arriva in kb quindi va convertito in b */
        },
        methods: {
            changeFile(ev) {
                for ( const k in ev.target.files) {
                    const curFile = ev.target.files[k];
                    if (this.realMaxSize) {
                        if (curFile.size > this.realMaxSize) return showWarning("Il file "+curFile.name+" supera le dimensioni consentite di "+formatBytes(this.realMaxSize,0));
                    }
                    if (typeof this.$root.configApp.maxUploadSize !== 'undefined' && this.$root.configApp.maxUploadSize) {
                        if (curFile.size > this.$root.configApp.maxUploadSize) return showWarning("Il file "+curFile.name+" supera le dimensioni consentite dal server di "+formatBytes(this.$root.configApp.maxUploadSize,0));
                    }
                    if (this.accept && curFile.type) {
                        if (!this.accept.split(",").includes(curFile.type)) return showWarning("Il file deve essere delle seguenti tipologie: "+this.accept.split(","));
                    }
                }
                this.file = ev.target.files;
                this.$emit('on-picker',{files:this.file});
            },
        }
    }
</script>